export enum Environment {
  DEV = 'dev',
  INT = 'int',
  PROD = 'prod',
}
